import { EndpointError } from '@square/ignition';
import { Heading20, Box } from '@squareup/dex-ui-shared-base';
import { humanizeName } from '@squareup/dex-utils-text';
import React, { FunctionComponent } from 'react';

import { ErrorRow } from '../../ErrorRow';

import styles from './reference-error-table.module.css';

interface ReferenceErrorTableProps {
  tableName: string;
  errors: EndpointError[] | undefined;
  changeRow(errorProperty: EndpointError): void;
  selectedErrorRow: EndpointError;
}

const ReferenceErrorTable: FunctionComponent<ReferenceErrorTableProps> = ({
  tableName,
  errors,
  changeRow,
  selectedErrorRow,
}) => {
  return (
    <Box margin={{ bottom: '4x', top: '4x' }}>
      <Box
        className={styles['title-container']}
        border={{ line: { bottom: 'standard' } }}
        padding={{ bottom: '2x' }}
      >
        <span className={styles['section-title']}>
          <Heading20>{humanizeName(tableName)}</Heading20>
        </span>
      </Box>
      <Box margin={{ top: '4x' }}>
        {errors?.map((error: EndpointError) => {
          return (
            <ErrorRow
              key={error.name}
              errorProperty={error}
              changeRow={changeRow}
              selectedErrorRow={selectedErrorRow}
            ></ErrorRow>
          );
        })}
      </Box>
    </Box>
  );
};

export { ReferenceErrorTable };
